enum FileStoragePermissionTypes {
  Read = 1,
  Write = 2,
}

export default FileStoragePermissionTypes;
